<template>
  <div :class="$style.ksFormGiftCodeBox" :style="{ backgroundImage: `url(${backgrounImgUrl}/bg31.jpg)` }">
    <div :class="$style.content">
      <!-- 礼包码 -->
      <div :class="$style.codeContent" :style="{ backgroundImage: `url(${backgrounImgUrl}/giftcode1.png)` }">
        <div :class="$style.code">
          <div :class="$style.codenum">
            {{ cdk }}
          </div>
          <div :class="[$style.copy, 'copyBtn']" @click="copyCdk" :style="{ backgroundImage: `url(${backgrounImgUrl}/btnbg1.png)` }">
            复制
          </div>
        </div>
      </div>
      <!-- 立即体验按钮 -->
      <div :class="$style.btn" @click="downloadGame">
        <van-image
          width="200"
          height="80"
          fit="cover"
          mode="aspectFil"
          :src="`${backgrounImgUrl}/downloadbtn1.png`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Image as VanImage, Toast } from 'vant';
import Clipboard from "clipboard";
import { getUserRewardInfo } from '@/apis/ksForm'
import { backgrounImgUrl } from './config'

export default {
  name: 'ksActivity-giftcode',
  components: {
    VanImage,
  },
 
  data () {
    return {
      backgrounImgUrl,
      cdk: '', // 礼包码
      historyMobile: '',
      extraParams: {}
    }
  },
  created () {
    this.extraParams = JSON.parse(localStorage.getItem('ksActivityQuery')) || {}
    const query = this.$route.query
    if (query.cdk) {
      this.cdk = query.cdk
    } else {
      this.historyMobile = localStorage.getItem("ksFormMobile") || ''
      this.onCheckRewardRecord()
    }
    
  },
  methods: {
    onCheckRewardRecord () {
      if (this.historyMobile && this.extraParams.appkey) {
        getUserRewardInfo({
          mobile: this.historyMobile,
          gameId: this.extraParams.appkey
        }).then(res => {
          if (res.data) {
            this.cdk = res.data.cdk
          }
        }).catch(() => {})
      }
    },
    copyCdk () {
      let that = this;
      if (!that.cdk) return;
      let clipboard = new Clipboard(".copyBtn", {
        text: function (trigger) {
          //返回字符串
          return `${that.cdk}`;
        },
      });
      clipboard.on("success", (e) => {
        //复制成功
        Toast('复制成功');
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        //复制失败
        clipboard.destroy();
      });
    },

    // 立即体验下载游戏
    downloadGame () {
      window.open(`${this.extraParams.download_url}`, '_blank')
    }
  }
}

</script>

<style lang="scss" module>
.ksFormGiftCodeBox {
  width: 100%;
  height: 100vh;
  // background-image: url('./qietu/bg3.jpg');
  background-size: 100% 100%;
  background-position: center; /* 让图片居中显示 */  
  background-repeat: no-repeat;
  display: flex;  
  justify-content: center;  
  align-items: center;  
  .content {
    width: 300px;
    height: 200px;
    text-align: center;
    .codeContent {
      width: 300px;
      height: 110px;
      // background-image: url('./qietu/giftcode.png');
      background-size: 100% 100%;
      background-position: center; /* 让图片居中显示 */  
      background-repeat: no-repeat;
      .code {
        width: 260px;
        margin-left: 25px;
        padding-top: 48px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .codenum {
          font-size: 13px;
          font-family: Dream Han Sans SC, Dream Han Sans SC-W22;
          font-weight: bold;
          text-align: center;
          color: #71361d;
          // letter-spacing: 0.53px;
        }
        .copy {
          width: 81px;
          height: 22px;
          text-align: center;
          font-size: 13px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 500;
          color: #413129;
          line-height: 21px;
          // box-shadow: -1.33px 0px 0.33px 1.33px rgba(28,25,22,0.30); 
          // background-image: url('./qietu/btnbg.png');
          background-size: 100% 100%;
          background-position: center; /* 让图片居中显示 */  
          background-repeat: no-repeat;
        }
      }
    }
    .btn {
      width: 300px;
      height: 105px;
    }
  }
}
</style>